module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-DISCORD.66ba6032.png";